import {createContext} from 'shared/web';

import {NotificationsContextProps} from '../Notification.types';

const [NotificationContextProvider, useNotificationContext] =
  createContext<NotificationsContextProps>({
    strict: false,
    name: 'NotificationContext',
  });

export {NotificationContextProvider, useNotificationContext};
